import { Modal, Spin, Table, Timeline } from 'antd'
import moment from 'moment'
import React,{useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import  './sowAuditLog.css';
import { fetchAuditlog } from '../../store/reducers/orderDashboardSlice';

const SOWAuditLog = (props:any) => {
  const dispatch = useDispatch();
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  const [sowHistoryList, setSowHistoryList] = React.useState([]);

  useEffect(() => {
      if(props.visible){
        dispatch(fetchAuditlog({id:props.selectedSOW.sowId, module: "sow"}))
        .then(
          (response: any) => {
            if (response.type !== 'orderDashboard/fetchAuditlog/fulfilled') {
              rejectedApiMessage(response.payload);
            }
            else{
                setSowHistoryList(response.payload);
            }
          }
        );

        // props.getAuditLog(props.selectedemployeeData?.id)
      }else{
        setSowHistoryList([]);

      }
  }, [props.visible])
  
  return (
    <Modal
    title="SOW History"
    open={props.visible}
    onCancel={()=>props.onCancel()}
    footer={null}
    width={1000}
    styles={{
      content: {
        borderRadius: '0',
        borderTop: '4px solid #1677ff',
        font: 'normal normal normal 14px/20px Nunito Sans',
        zIndex: 9998,
      },
    }}
    >
    <Spin spinning ={orderDashboardData.loading }>
      <div>
        <p>
          <b>SOW Id:</b> {props.selectedSOW.sowId}
        </p>
        {/* <p>
          <b>User Email:</b> {selectedemployeeData?.email}
        </p> */}
      </div>
      <Table
        dataSource={sowHistoryList}
        scroll={{ x: 'max-content',y: 300}}
        className='table-style'
        columns={[
          {
            title: 'Modified By',
            dataIndex: 'createdBy',
            key: 'createdBy',
            width:'100px'
          },
          {
            title: 'Modified On',
            dataIndex: 'createdDate',
            key: 'createdDate',
            width:'150px',
            render: timeStamp => {
              return moment(timeStamp).format('YYYY-MM-DD hh:mm A')
            }
          },
        //   {
        //     title: 'Reason',
        //     dataIndex: 'reason',
        //     key: 'reason',
        //     width:'20%'
        //   },
          {
            title: 'Events',
            dataIndex: 'events',
            key: 'events',
            width:'400px',
            render: changes => {
              if (changes.length <= 0) {
                return 'No changes are recorded'
              }
              return changes.map((items:any) => {
                return <Timeline className ="sowAuditLog" >
                  <Timeline.Item style={{minHeight:'0', font: 'normal normal 600 12px/16px Nunito Sans'}}>{items}</Timeline.Item>
                </Timeline>

              })
            }
          },

        ]}
        // loading={userDashboard?.loading}
      />
    </Spin>
  </Modal>
  )
}
export default SOWAuditLog;
